import { Component, Input } from '@angular/core';
import {
  HostedPaymentNotes,
  ModifiedSessionDocumentInfo,
  SessionPaymentTransaction,
  Tenant,
} from '../../../models';
import { CustomerPayment } from '../../../models/payment-document.model';
import { TemplateField } from '../../../models/session/template-field.model';

@Component({
  selector: 'payment-summary-print',
  templateUrl: './payment-summary-print.component.html',
  styleUrls: ['./payment-summary-print.component.scss'],
})
export class PaymentSummaryPrintComponent {
  @Input() customerPayment: CustomerPayment;
  @Input() tenantDetails: Tenant;
  @Input() documents: ModifiedSessionDocumentInfo[];
  @Input() transactions: SessionPaymentTransaction[];
  @Input() hasMultipleTransactions: boolean;
  @Input() transactionBuyerAccounts: string[];
  @Input() transactionsTotal: number;
  @Input() transactionsSubTotal: number;
  @Input() transactionsCreditTotal: number;
  @Input() transactionsAppliedDiscountTotal: number;
  @Input() transactionsSurchargeTotal: number;
  @Input() isDiscountAmountVisible: boolean;
  @Input() isSurchargeFeeVisible: boolean;
  @Input() hasDocuments = true;
  @Input() displayReference = false;
  @Input() referenceNumber: string;
  @Input() referenceDate: Date;
  @Input() accountNumberLabel: string;
  @Input() dropdownSelection: string;
  @Input() dropdownSettings: HostedPaymentNotes;
  @Input() paymentNotes: string;
  @Input() paymentNoteSettings: HostedPaymentNotes;
  @Input() displayCustomFields: boolean;
  @Input() customTemplateFields?: TemplateField[];

  get standardTemplateFields(): TemplateField[] {
    return (this.customTemplateFields ?? []).filter(
      (f) => !f.isCustom && f.type !== 'FreeTextNote',
    );
  }

  get orderedCustomFields(): TemplateField[] {
    return (this.customTemplateFields ?? []).filter((f) => f.isCustom);
  }

  get printPaymentNoteField(): TemplateField | null {
    return (
      (this.customTemplateFields ?? []).find(
        (f) => !f.isCustom && f.type === 'FreeTextNote',
      ) ?? null
    );
  }

  showPoColumn() {
    return this.documents?.some(
      (d) => d.poNumber !== null && d.poNumber.length > 0,
    );
  }

  showAccountColumn() {
    return this.documents?.some(
      (d) => d.buyerAccount !== this.documents[0].buyerAccount,
    );
  }

  showDiscountAppliedColumn() {
    return this.transactions?.some((t) => t.totalDiscount > 0);
  }

  showCreditMemoColumn() {
    return this.transactions?.some((t) => t.totalCredit < 0);
  }
}
